import { defineMessages } from 'react-intl'

const translations = defineMessages({
  productStatus: {
    defaultMessage: 'Status: {status}',
    id: 'msp.account.order_history.order_detail.status.mobile'
  },
  statusCancelled: {
    defaultMessage: 'cancelled',
    id: 'msp.account.order_history.order_detail.status.cancelled'
  },
  statusDelivered: {
    defaultMessage: 'delivered',
    id: 'msp.account.order_history.order_detail.status.delivered'
  },
  statusShipped: {
    defaultMessage: 'shipped',
    id: 'msp.account.order_history.order_detail.status.shipped'
  },
  statusNotShipped: {
    defaultMessage: 'not shipped',
    id: 'msp.account.order_history.order_detail.status.not_shipped'
  },
  statusReturned: {
    defaultMessage: 'returned',
    id: 'msp.account.order_history.order_detail.status.returned'
  },
  statusPartiallyReturned: {
    defaultMessage: 'partially returned',
    id: 'msp.account.order_history.order_detail.status.partiallyReturned'
  },
  articleNumber: {
    defaultMessage: 'Article Number: {articleNo}',
    id: 'msp.account.order_history.order_detail.article_number'
  },
  tableArticle: {
    defaultMessage: 'Article',
    id: 'msp.account.order_history.order_detail.table.article'
  },
  tableQuantity: {
    defaultMessage: 'Quantity',
    id: 'msp.account.order_history.order_detail.table.quantity'
  },
  tableUnitPrice: {
    defaultMessage: 'Unit Price',
    id: 'msp.account.order_history.order_detail.table.unit_price'
  },
  tableStatus: {
    defaultMessage: 'Status',
    id: 'msp.account.order_history.order_detail.table.status'
  },
  tableTotal: {
    defaultMessage: 'Total',
    id: 'msp.account.order_history.order_detail.table.total'
  }
})

export default translations
